import React, { ReactElement, useState, useEffect } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Programme } from '../../../../types/entity.types';
import { RootState } from '../../../../types/state/root.types';

import { ACTIVE, ARCHIVED, UPCOMING } from '../../../../utils/constants';

import ProgrammeMenuSection from './programme-menu-section/ProgrammeMenuSection';

import './programme-menu.scss';

type Props = {
  onNavigate?: (value: string) => void;
};

const ProgrammeMenu = ({ onNavigate }: Props): ReactElement => {
  const navigate: NavigateFunction = useNavigate();

  const programmes: Programme[] | undefined = useSelector(
    ({ programme }: RootState): Programme[] | undefined => programme.programmes
  );

  const [activeProgrammes, setActiveProgrammes] = useState<Programme[]>([]);
  const [upcomingProgrammes, setUpcomingProgrammes] = useState<Programme[]>([]);
  const [archivedProgrammes, setArchivedProgrammes] = useState<Programme[]>([]);

  useEffect((): void => {
    if (programmes) {
      setActiveProgrammes([...programmes.filter((programme: Programme): boolean => programme.status === ACTIVE)]);
      setUpcomingProgrammes([...programmes.filter((programme: Programme): boolean => programme.status === UPCOMING)]);
      setArchivedProgrammes([...programmes.filter((programme: Programme): boolean => programme.status === ARCHIVED)]);
    }
  }, [programmes]);

  return (
    <div className="programme-menu" data-testid="programme-menu">
      <div className="programme-menu__items">
        <ProgrammeMenuSection heading="Active Programmes" programmes={activeProgrammes} onNavigate={onNavigate} />
        <ProgrammeMenuSection heading="Upcoming Programmes" programmes={upcomingProgrammes} onNavigate={onNavigate} />
        <ProgrammeMenuSection heading="Archived Programmes" programmes={archivedProgrammes} onNavigate={onNavigate} />
      </div>
      <div className="programme-menu__button" onClick={(): void => navigate('/programmes/new/general')}>
        <FontAwesomeIcon icon={faPlus} />
        <span>Create New Programme</span>
      </div>
    </div>
  );
};

export default ProgrammeMenu;
